import React from 'react';

import { messages } from '@qality/common-messages';

const NoTestCases = (): JSX.Element => {
  return <div>{messages['noTestCases.message']}</div>;
};

export default NoTestCases;
